// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ReportsFreedomChart_wrap__3z1pa","wrap_updating":"ReportsFreedomChart_wrap_updating__OlYUM common_updating__10bHv"};